export class UnauthorizedError extends Error {
  constructor() {
    super('Session expired. Please complete the verification again.');
    this.name = 'UnauthorizedError';
  }
}

export class AccessDeniedError extends Error {
  constructor(msg?: string) {
    super(
      msg ||
        'Access denied. You do not have permission to perform this action.',
    );
    this.name = 'AccessDeniedError';
  }
}

export type RateLimitScope = 'system' | 'session';

export class RateLimitError extends Error {
  scope: RateLimitScope;

  constructor(msg?: string, scope: RateLimitScope = 'session') {
    super(msg || 'The AI chat usage limit has been reached.');
    this.name = 'RateLimitError';
    this.scope = scope;
  }
}
